import './styles.scss';

export const InputSeoComponent = ({fields}) => {
  return (
    <div className="seo-inputs-container">
            {fields.map((field, index) => {
                const length = field.value?.length || 0;
                const isOver = length > field.maxLength;
                return (
                    <div key={index} className={`${field.wrapperClass || ""}`}>
                        <div className="input-group inputs-seo">

                            <label className={`${isOver ? 'error': ''}`}>{field.label}</label>

                            <input
                                className={`form-control ${isOver ? 'seo-over' : ''}`}
                                type={field.type || "text"}
                                value={field.value}
                                onChange={(e) => field.onChange(e.target.value)}
                                placeholder={field.placeholder}
                            />

                            <p className={`input-caracteres ${isOver ? 'error' : ''}`}>
                                {length} caracteres (máximo recomendado: {field.maxLength})
                            </p>

                        </div>
                    </div>
                );
            })}
        </div>
  )
}